import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { rootSaga } from '../sagas';
import {
  offer,
  dictionaries,
  user,
  savedOffer,
  abExperiments,
  publishTerms,
  betPosition,
  fairPlay,
  checkoutInfo,
  auction,
  topBets,
  coworkingCombinedReducer,
  calltracking,
  publishInfo,
  publishAvailable,
  visibleViolations,
  config,
  layout,
  dealRentVersion,
  businessAppointmentsReducer,
} from '../redux/reducers';
import { draft } from '../reducers/draft';
import { rosreestrData } from '../reducers/rosreestrData';
import { IAppState } from '../types/reducers';
import { ISagaContext } from '../types/sagas';
import { buyPackage } from '../reducers/buyPackage';
import { termsDurations } from '../reducers/termsDurations';
import { paymentProvidersReducer } from './paymentProviders';
import { billingStatusReducer } from './billingStatus';
import { depositAccountReducer } from './depositAccount';
import { recommendedPackages } from './recommendedPackages';

let store: Store<IAppState>;

export function initStore(context: ISagaContext) {
  const initialState = context.config.getStrict<IAppState>('initialState');

  const rootReducer = combineReducers<IAppState>({
    abExperiments,
    auction,
    betPosition,
    billingStatus: billingStatusReducer,
    businessAppointments: businessAppointmentsReducer,
    buyPackage,
    calltracking,
    checkoutInfo,
    config,
    coworking: coworkingCombinedReducer,
    dealRentVersion,
    depositAccount: depositAccountReducer,
    dictionaries,
    draft,
    fairPlay,
    layout,
    offer,
    paymentProviders: paymentProvidersReducer,
    publishAvailable,
    publishInfo,
    publishTerms,
    rosreestrData,
    savedOffer,
    termsDurations,
    topBets,
    user,
    visibleViolations,
    recommendedPackages,
  });

  const thunkMiddleware = thunk.withExtraArgument(context);
  const sagaMiddleware = createSagaMiddleware({ context });

  // istanbul ignore next
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'add-form-frontend',
        trace: true,
        traceLimit: 25,
      })) ||
    compose;

  store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunkMiddleware, sagaMiddleware)));

  sagaMiddleware.run(rootSaga);

  return store;
}

export const getStore = () => {
  if (!store) {
    throw new Error('Redux не инициализирован');
  }

  return store;
};
